// Shared constants for responsive breakpoints and animation timings
export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
};

export const CAROUSEL_TIMING = {
  AUTO_SCROLL_INTERVAL: 4000,
};
